import React from 'react';
import PropTypes from 'prop-types';
import useSortedData from '../hooks/useSortedData'; 
import usePagination from '../hooks/usePagination';
import { formatNumber, getSortIndicator } from '../../../utils/helpers';
import '../components/ContestInfo.css'; 
import './ParticipantsTable.css';
import './Tables.css';

// Placeholder component for Esports Registering state
const ParticipantsTableEsportsRegistering = ({ contest }) => {
  const playersPerPage = 20;

  // Initial sort by salary descending
  const { sortedData: sortedPlayers, requestSort, sortConfig } = useSortedData(contest.players, 'salary', 'descending');
  const { currentItems: currentPlayers, nextPage, prevPage, currentPage } = usePagination(sortedPlayers, playersPerPage);

  return (
    <div className="participants-table-container">
      <div className="participants-table-header">
        <span className="participants-table-header-text">PLAYERS ({contest.players.length})</span>
      </div>
      <table className="participants-table-registering">
        <thead>
          <tr>
            <th onClick={() => requestSort('name')}>
              NAME {getSortIndicator(sortConfig, 'name')}
            </th>
            <th onClick={() => requestSort('sportSpecificData.seed')}>
              SEED {getSortIndicator(sortConfig, 'sportSpecificData.seed')}
            </th>
            {contest.format !== 'H2H' && contest.draftType !== 'Snake' && (
              <th onClick={() => requestSort('salary')}>
                SALARY {getSortIndicator(sortConfig, 'salary')}
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {currentPlayers.map((player, index) => (
            <tr key={index}>
              <td>{player.name}</td>
              <td>{player.sportSpecificData?.seed ?? 'N/A'}</td>
              {contest.format !== 'H2H' && contest.draftType !== 'Snake' && <td>${formatNumber(player.salary)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
      {sortedPlayers.length > playersPerPage && (
        <div className="pagination-controls">
          <button onClick={prevPage} disabled={currentPage === 1}>Back</button>
          <span>Page {currentPage}</span>
          <button onClick={nextPage} disabled={currentPage * playersPerPage >= sortedPlayers.length}>Next</button>
        </div>
      )}
    </div>
  );
};

ParticipantsTableEsportsRegistering.propTypes = {
  contest: PropTypes.shape({
    players: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      salary: PropTypes.number,
      sportSpecificData: PropTypes.shape({
        seed: PropTypes.number
      })
    })).isRequired,
    format: PropTypes.string.isRequired,
    draftType: PropTypes.string
  }).isRequired
};

export default ParticipantsTableEsportsRegistering; 